import { render, staticRenderFns } from "./Q14.vue?vue&type=template&id=8f976e04&"
import script from "./Q14.vue?vue&type=script&lang=ts&"
export * from "./Q14.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports